export default __webpack_public_path__ + "static/media/b3 old.324024ff.png";